import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  countries: {
    id: 'product_jp_reassurance_marketplace_countries',
    defaultMessage: "We're open in 17 countries",
  },
  title: {
    id: 'product_jp_reassurance_marketplace_title',
    defaultMessage: "World's largest refurbished marketplace",
  },
} as Record<string, I18nDefinition>
